<h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Saldo por SKU por Mes
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
        <p class="mb-0">
            <span class="grey-text">Reportes y Consultas</span>
            <span> /</span>
            <span class="grey-text">Inventario</span>
            <span> /</span>
            <span>Saldo por SKU por Mes</span>
        </p>
    </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
    <div class="card mb-2 wow detalle-cliente">
        <div class="card-body justify-content-between">
            <div class="row filtros-body">
                <div class="col" style="max-width: 300px;">
                    <div class="md-form">
                        <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true"
                            [highlightFirst]="false" placeholder="Seleccionar Bodega" formControlName="bodega">
                        </mdb-select>
                        <label>Bodega</label>
                    </div>
                </div>
                <div class="col" style="max-width: 300px;">
                    <div class="md-form">
                        <mdb-select [options]="optionsMonth" [filterEnabled]="true" [highlightFirst]="false"
                            placeholder="Mes" formControlName="mes"></mdb-select>
                        <label>Mes</label>
                    </div>
                </div>
                <div class="col" style="max-width: 300px;">
                    <div class="md-form">
                        <mdb-select [options]="optionsYear" [filterEnabled]="true" [highlightFirst]="false"
                            placeholder="Año" formControlName="anho"></mdb-select>
                        <label>Año</label>
                    </div>
                </div>
            </div>

            <div class="row filtros-body align-items-center">
                <div class="col" style="max-width: 150px;">
                    <div class="md-form">
                        <input value="" type="text" id="codProduct" class="form-control" placeholder="000" #codProduct
                            formControlName="sku" />
                        <label for="codProduct">Código de producto</label>
                        <!-- <div *ngIf="
                              formHeader.get('sku').invalid &&
                              (formHeader.get('sku').dirty ||
                              formHeader.get('sku').touched)
                            ">
                        <mdb-error *ngIf="formHeader.get('sku').hasError('required')">
                          Ingrese código de producto
                        </mdb-error>
                        <mdb-error *ngIf="formHeader.get('sku').hasError('min')">
                          Código de producto debe ser mayor a 0 </mdb-error>
                      </div> -->
                    </div>
                </div>
                <div class="col d-flex">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                        (click)="openModalSeleccionarProducto()">
                        <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                    <h6 class="text-info" style="display: contents;" *ngIf="productoSeleccionado">
                        {{ productoSeleccionado.descripcion}}
                    </h6>
                </div>
            </div>
        </div>
        <!-- FOOTER -->
        <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
            <div></div>
            <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
                <mdb-icon fas icon="search"></mdb-icon>
                Buscar
            </button>
        </div>
    </div>
</form>

<div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">

        <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

        <div class="table-responsive" *ngIf="listaMovimientos">

            <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
            </app-no-data-alert>

            <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos?.length > 0">
                <thead class="grey lighten-2">
                    <tr>
                        <th scope="col">Fecha</th>
                        <th scope="col">SKU</th>
                        <th scope="col">Producto</th>
                        <th scope="col">Formato</th>
                        <th scope="col">Bodega</th>
                        <th scope="col" style="text-align: right;">Saldo actual</th>
                        <th scope="col" style="text-align: right;">Ingreso</th>
                        <th scope="col" style="text-align: right;">Salidas</th>
                        <th scope="col" style="text-align: right;">Saldo Final</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let movimiento of listaMovimientos">
                        <td>{{movimiento.fecha_movimiento | fecha}}</td>
                        <td>{{movimiento.sku}}</td>
                        <td>{{movimiento.producto_descripcion}}</td>
                        <td>{{movimiento.formato_nombre}}</td>
                        <td>{{movimiento.bodega_nombre}}</td>
                        <td align="right">{{movimiento.saldo_inicial | numerico}}</td>

                        <td *ngIf="movimiento.ingresos > 0" align="right">{{movimiento.ingresos | numerico}}</td>
                        <td *ngIf="movimiento.ingresos === 0"></td>

                        <td *ngIf="movimiento.salidas > 0" align="right">{{movimiento.salidas | numerico}}</td>
                        <td *ngIf="movimiento.salidas === 0"></td>

                        <td align="right">{{movimiento.saldo | numerico}}</td>
                    </tr>
                </tbody>

                <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                    *ngIf="listaMovimientos?.length > 0"></app-pagination>

            </table>
        </div>
    </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
    <div class="card-body d-sm-flex p-1 justify-content-end">
        <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="exportarExcel()">
            Excel
        </button>

        <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
            PDF
        </button>
    </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
    (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-producto>